// extracted by mini-css-extract-plugin
export default {"container":"KeyValueText_container__2kL1t"};